import React, { useEffect, useRef, useState } from 'react';

import { ModalProvider } from '@magoosh/context/modal_context';
import { PrimaryButton } from '@magoosh/lib/button';
import StartButton from '@magoosh/organisms/practice_sessions/start_button';

interface Props {
  activityName?: string;
  children: string;
  speakingExamSectionIds?: number[];
}

const examSectionInputName = 'practice_session[exam_section_id]';

const selectedExamSectionId = (form: HTMLFormElement): number | null => {
  const select = form.querySelector(
    `select[name="${examSectionInputName}"]`
  ) as HTMLSelectElement | null;
  const radio = form.querySelector(
    `input[type="radio"][name="${examSectionInputName}"]:checked`
  ) as HTMLInputElement | null;
  const value = select?.value ?? radio?.value;
  return value ? parseInt(value, 10) : null;
};

const FormStartButton = (props: Props) => {
  const containerRef = useRef<HTMLSpanElement>(null);
  const [includesSpeaking, setIncludesSpeaking] = useState(false);

  useEffect(() => {
    const ids = props.speakingExamSectionIds;
    if (!ids || ids.length === 0) return;

    const form = containerRef.current?.closest('form');
    if (!form) return;

    const update = () => {
      const id = selectedExamSectionId(form);
      setIncludesSpeaking(id !== null && ids.indexOf(id) !== -1);
    };

    update();
    form.addEventListener('change', update);
    return () => form.removeEventListener('change', update);
  }, [props.speakingExamSectionIds]);

  const submitForm = () => {
    const form = containerRef.current?.closest('form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  };

  return (
    <span ref={containerRef} style={{ display: 'contents' }}>
      <StartButton
        Button={PrimaryButton}
        activityName={props.activityName}
        includesSpeaking={includesSpeaking}
        onStart={submitForm}
      >
        {props.children}
      </StartButton>
    </span>
  );
};

export default (props: Props) => (
  <ModalProvider>
    <FormStartButton {...props} />
  </ModalProvider>
);
